/*
 * Generated by PEG.js 0.10.0.
 *
 * http://pegjs.org/
 */
"use strict";

function peg$subclass(child, parent) {
  function ctor() {
    this.constructor = child;
  }

  ctor.prototype = parent.prototype;
  child.prototype = new ctor();
}

function peg$SyntaxError(message, expected, found, location) {
  this.message = message;
  this.expected = expected;
  this.found = found;
  this.location = location;
  this.name = "SyntaxError";

  if (typeof Error.captureStackTrace === "function") {
    Error.captureStackTrace(this, peg$SyntaxError);
  }
}

peg$subclass(peg$SyntaxError, Error);

peg$SyntaxError.buildMessage = function (expected, found) {
  var DESCRIBE_EXPECTATION_FNS = {
    literal: function literal(expectation) {
      return "\"" + literalEscape(expectation.text) + "\"";
    },
    "class": function _class(expectation) {
      var escapedParts = "",
          i;

      for (i = 0; i < expectation.parts.length; i++) {
        escapedParts += expectation.parts[i] instanceof Array ? classEscape(expectation.parts[i][0]) + "-" + classEscape(expectation.parts[i][1]) : classEscape(expectation.parts[i]);
      }

      return "[" + (expectation.inverted ? "^" : "") + escapedParts + "]";
    },
    any: function any(expectation) {
      return "any character";
    },
    end: function end(expectation) {
      return "end of input";
    },
    other: function other(expectation) {
      return expectation.description;
    }
  };

  function hex(ch) {
    return ch.charCodeAt(0).toString(16).toUpperCase();
  }

  function literalEscape(s) {
    return s.replace(/\\/g, '\\\\').replace(/"/g, '\\"').replace(/\0/g, '\\0').replace(/\t/g, '\\t').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/[\x00-\x0F]/g, function (ch) {
      return '\\x0' + hex(ch);
    }).replace(/[\x10-\x1F\x7F-\x9F]/g, function (ch) {
      return '\\x' + hex(ch);
    });
  }

  function classEscape(s) {
    return s.replace(/\\/g, '\\\\').replace(/\]/g, '\\]').replace(/\^/g, '\\^').replace(/-/g, '\\-').replace(/\0/g, '\\0').replace(/\t/g, '\\t').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/[\x00-\x0F]/g, function (ch) {
      return '\\x0' + hex(ch);
    }).replace(/[\x10-\x1F\x7F-\x9F]/g, function (ch) {
      return '\\x' + hex(ch);
    });
  }

  function describeExpectation(expectation) {
    return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation);
  }

  function describeExpected(expected) {
    var descriptions = new Array(expected.length),
        i,
        j;

    for (i = 0; i < expected.length; i++) {
      descriptions[i] = describeExpectation(expected[i]);
    }

    descriptions.sort();

    if (descriptions.length > 0) {
      for (i = 1, j = 1; i < descriptions.length; i++) {
        if (descriptions[i - 1] !== descriptions[i]) {
          descriptions[j] = descriptions[i];
          j++;
        }
      }

      descriptions.length = j;
    }

    switch (descriptions.length) {
      case 1:
        return descriptions[0];

      case 2:
        return descriptions[0] + " or " + descriptions[1];

      default:
        return descriptions.slice(0, -1).join(", ") + ", or " + descriptions[descriptions.length - 1];
    }
  }

  function describeFound(found) {
    return found ? "\"" + literalEscape(found) + "\"" : "end of input";
  }

  return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
};

function peg$parse(input, options) {
  options = options !== void 0 ? options : {};

  var peg$FAILED = {},
      peg$startRuleFunctions = {
    start: peg$parsestart
  },
      peg$startRuleFunction = peg$parsestart,
      peg$c0 = " ",
      peg$c1 = peg$literalExpectation(" ", false),
      peg$c2 = function peg$c2(cells, side, hand, turn) {
    return {
      cells: cells,
      side: side,
      hand: hand,
      turn: turn
    };
  },
      peg$c3 = function peg$c3(tokens) {
    var result = [];
    var row = [];
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = tokens[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var token = _step.value;

        switch (token.type) {
          case "piece":
            row.push(token.data);
            break;

          case "blankCells":
            for (var i = 0; i < token.count; i++) {
              row.push(null);
            }

            break;

          case "newLine":
            result.push(row);
            row = [];
            break;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    result.push(row);
    return result;
  },
      peg$c4 = /^[lnsgkprbLNSGKPRB]/,
      peg$c5 = peg$classExpectation(["l", "n", "s", "g", "k", "p", "r", "b", "L", "N", "S", "G", "K", "P", "R", "B"], false, false),
      peg$c6 = function peg$c6(piece) {
    var side = "b";
    if (piece == piece.toLowerCase()) side = "w";
    return {
      type: "piece",
      data: {
        piece: piece.toLowerCase(),
        side: side
      }
    };
  },
      peg$c7 = function peg$c7(count) {
    return {
      type: "blankCells",
      count: count
    };
  },
      peg$c8 = "/",
      peg$c9 = peg$literalExpectation("/", false),
      peg$c10 = function peg$c10() {
    return {
      type: "newLine"
    };
  },
      peg$c11 = "+",
      peg$c12 = peg$literalExpectation("+", false),
      peg$c13 = /^[bw]/,
      peg$c14 = peg$classExpectation(["b", "w"], false, false),
      peg$c15 = function peg$c15(entries) {
    var result = {
      b: getEmptyHand(),
      w: getEmptyHand()
    };
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = entries[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var entry = _step2.value;
        result[entry.side][entry.piece] = entry.count;
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    return result;
  },
      peg$c16 = /^[lnsgprbLNSGPRB]/,
      peg$c17 = peg$classExpectation(["l", "n", "s", "g", "p", "r", "b", "L", "N", "S", "G", "P", "R", "B"], false, false),
      peg$c18 = function peg$c18(count, piece) {
    var side = "b";
    if (piece == piece.toLowerCase()) side = "w";
    if (count == null) count = 1;
    return {
      piece: piece.toLowerCase(),
      count: count,
      side: side
    };
  },
      peg$c19 = "-",
      peg$c20 = peg$literalExpectation("-", false),
      peg$c21 = function peg$c21() {
    return {
      b: getEmptyHand(),
      w: getEmptyHand()
    };
  },
      peg$c22 = /^[0-9]/,
      peg$c23 = peg$classExpectation([["0", "9"]], false, false),
      peg$c24 = function peg$c24(integer) {
    return parseInt(integer, 10);
  },
      peg$currPos = 0,
      peg$savedPos = 0,
      peg$posDetailsCache = [{
    line: 1,
    column: 1
  }],
      peg$maxFailPos = 0,
      peg$maxFailExpected = [],
      peg$silentFails = 0,
      peg$resultsCache = {},
      peg$result;

  if ("startRule" in options) {
    if (!(options.startRule in peg$startRuleFunctions)) {
      throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
    }

    peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
  }

  function text() {
    return input.substring(peg$savedPos, peg$currPos);
  }

  function location() {
    return peg$computeLocation(peg$savedPos, peg$currPos);
  }

  function expected(description, location) {
    location = location !== void 0 ? location : peg$computeLocation(peg$savedPos, peg$currPos);
    throw peg$buildStructuredError([peg$otherExpectation(description)], input.substring(peg$savedPos, peg$currPos), location);
  }

  function error(message, location) {
    location = location !== void 0 ? location : peg$computeLocation(peg$savedPos, peg$currPos);
    throw peg$buildSimpleError(message, location);
  }

  function peg$literalExpectation(text, ignoreCase) {
    return {
      type: "literal",
      text: text,
      ignoreCase: ignoreCase
    };
  }

  function peg$classExpectation(parts, inverted, ignoreCase) {
    return {
      type: "class",
      parts: parts,
      inverted: inverted,
      ignoreCase: ignoreCase
    };
  }

  function peg$anyExpectation() {
    return {
      type: "any"
    };
  }

  function peg$endExpectation() {
    return {
      type: "end"
    };
  }

  function peg$otherExpectation(description) {
    return {
      type: "other",
      description: description
    };
  }

  function peg$computePosDetails(pos) {
    var details = peg$posDetailsCache[pos],
        p;

    if (details) {
      return details;
    } else {
      p = pos - 1;

      while (!peg$posDetailsCache[p]) {
        p--;
      }

      details = peg$posDetailsCache[p];
      details = {
        line: details.line,
        column: details.column
      };

      while (p < pos) {
        if (input.charCodeAt(p) === 10) {
          details.line++;
          details.column = 1;
        } else {
          details.column++;
        }

        p++;
      }

      peg$posDetailsCache[pos] = details;
      return details;
    }
  }

  function peg$computeLocation(startPos, endPos) {
    var startPosDetails = peg$computePosDetails(startPos),
        endPosDetails = peg$computePosDetails(endPos);
    return {
      start: {
        offset: startPos,
        line: startPosDetails.line,
        column: startPosDetails.column
      },
      end: {
        offset: endPos,
        line: endPosDetails.line,
        column: endPosDetails.column
      }
    };
  }

  function peg$fail(expected) {
    if (peg$currPos < peg$maxFailPos) {
      return;
    }

    if (peg$currPos > peg$maxFailPos) {
      peg$maxFailPos = peg$currPos;
      peg$maxFailExpected = [];
    }

    peg$maxFailExpected.push(expected);
  }

  function peg$buildSimpleError(message, location) {
    return new peg$SyntaxError(message, null, null, location);
  }

  function peg$buildStructuredError(expected, found, location) {
    return new peg$SyntaxError(peg$SyntaxError.buildMessage(expected, found), expected, found, location);
  }

  function peg$parsestart() {
    var s0;
    var key = peg$currPos * 12 + 0,
        cached = peg$resultsCache[key];

    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }

    s0 = peg$parsesfen();
    peg$resultsCache[key] = {
      nextPos: peg$currPos,
      result: s0
    };
    return s0;
  }

  function peg$parsesfen() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    var key = peg$currPos * 12 + 1,
        cached = peg$resultsCache[key];

    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }

    s0 = peg$currPos;
    s1 = peg$parsecells();

    if (s1 !== peg$FAILED) {
      if (input.charCodeAt(peg$currPos) === 32) {
        s2 = peg$c0;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c1);
        }
      }

      if (s2 !== peg$FAILED) {
        s3 = peg$parseside();

        if (s3 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 32) {
            s4 = peg$c0;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;

            if (peg$silentFails === 0) {
              peg$fail(peg$c1);
            }
          }

          if (s4 !== peg$FAILED) {
            s5 = peg$parsehand();

            if (s5 !== peg$FAILED) {
              if (input.charCodeAt(peg$currPos) === 32) {
                s6 = peg$c0;
                peg$currPos++;
              } else {
                s6 = peg$FAILED;

                if (peg$silentFails === 0) {
                  peg$fail(peg$c1);
                }
              }

              if (s6 !== peg$FAILED) {
                s7 = peg$parseinteger();

                if (s7 !== peg$FAILED) {
                  peg$savedPos = s0;
                  s1 = peg$c2(s1, s3, s5, s7);
                  s0 = s1;
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    peg$resultsCache[key] = {
      nextPos: peg$currPos,
      result: s0
    };
    return s0;
  }

  function peg$parsecells() {
    var s0, s1, s2;
    var key = peg$currPos * 12 + 2,
        cached = peg$resultsCache[key];

    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }

    s0 = peg$currPos;
    s1 = [];
    s2 = peg$parsepiece();

    if (s2 === peg$FAILED) {
      s2 = peg$parseblankCells();

      if (s2 === peg$FAILED) {
        s2 = peg$parsenewLine();
      }
    }

    if (s2 !== peg$FAILED) {
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsepiece();

        if (s2 === peg$FAILED) {
          s2 = peg$parseblankCells();

          if (s2 === peg$FAILED) {
            s2 = peg$parsenewLine();
          }
        }
      }
    } else {
      s1 = peg$FAILED;
    }

    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$c3(s1);
    }

    s0 = s1;
    peg$resultsCache[key] = {
      nextPos: peg$currPos,
      result: s0
    };
    return s0;
  }

  function peg$parsepiece() {
    var s0, s1, s2, s3, s4;
    var key = peg$currPos * 12 + 3,
        cached = peg$resultsCache[key];

    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }

    s0 = peg$currPos;
    s1 = peg$currPos;
    s2 = peg$currPos;
    s3 = peg$parsepromotion();

    if (s3 === peg$FAILED) {
      s3 = null;
    }

    if (s3 !== peg$FAILED) {
      if (peg$c4.test(input.charAt(peg$currPos))) {
        s4 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s4 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c5);
        }
      }

      if (s4 !== peg$FAILED) {
        s3 = [s3, s4];
        s2 = s3;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
    } else {
      peg$currPos = s2;
      s2 = peg$FAILED;
    }

    if (s2 !== peg$FAILED) {
      s1 = input.substring(s1, peg$currPos);
    } else {
      s1 = s2;
    }

    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$c6(s1);
    }

    s0 = s1;
    peg$resultsCache[key] = {
      nextPos: peg$currPos,
      result: s0
    };
    return s0;
  }

  function peg$parseblankCells() {
    var s0, s1;
    var key = peg$currPos * 12 + 4,
        cached = peg$resultsCache[key];

    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }

    s0 = peg$currPos;
    s1 = peg$parseinteger();

    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$c7(s1);
    }

    s0 = s1;
    peg$resultsCache[key] = {
      nextPos: peg$currPos,
      result: s0
    };
    return s0;
  }

  function peg$parsenewLine() {
    var s0, s1;
    var key = peg$currPos * 12 + 5,
        cached = peg$resultsCache[key];

    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }

    s0 = peg$currPos;

    if (input.charCodeAt(peg$currPos) === 47) {
      s1 = peg$c8;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c9);
      }
    }

    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$c10();
    }

    s0 = s1;
    peg$resultsCache[key] = {
      nextPos: peg$currPos,
      result: s0
    };
    return s0;
  }

  function peg$parsepromotion() {
    var s0;
    var key = peg$currPos * 12 + 6,
        cached = peg$resultsCache[key];

    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }

    if (input.charCodeAt(peg$currPos) === 43) {
      s0 = peg$c11;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c12);
      }
    }

    peg$resultsCache[key] = {
      nextPos: peg$currPos,
      result: s0
    };
    return s0;
  }

  function peg$parseside() {
    var s0;
    var key = peg$currPos * 12 + 7,
        cached = peg$resultsCache[key];

    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }

    if (peg$c13.test(input.charAt(peg$currPos))) {
      s0 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s0 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c14);
      }
    }

    peg$resultsCache[key] = {
      nextPos: peg$currPos,
      result: s0
    };
    return s0;
  }

  function peg$parsehand() {
    var s0, s1, s2;
    var key = peg$currPos * 12 + 8,
        cached = peg$resultsCache[key];

    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }

    s0 = peg$currPos;
    s1 = [];
    s2 = peg$parsehandEntry();

    if (s2 !== peg$FAILED) {
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsehandEntry();
      }
    } else {
      s1 = peg$FAILED;
    }

    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$c15(s1);
    }

    s0 = s1;

    if (s0 === peg$FAILED) {
      s0 = peg$parseemptyHand();
    }

    peg$resultsCache[key] = {
      nextPos: peg$currPos,
      result: s0
    };
    return s0;
  }

  function peg$parsehandEntry() {
    var s0, s1, s2;
    var key = peg$currPos * 12 + 9,
        cached = peg$resultsCache[key];

    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }

    s0 = peg$currPos;
    s1 = peg$parseinteger();

    if (s1 === peg$FAILED) {
      s1 = null;
    }

    if (s1 !== peg$FAILED) {
      if (peg$c16.test(input.charAt(peg$currPos))) {
        s2 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s2 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c17);
        }
      }

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c18(s1, s2);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    peg$resultsCache[key] = {
      nextPos: peg$currPos,
      result: s0
    };
    return s0;
  }

  function peg$parseemptyHand() {
    var s0, s1;
    var key = peg$currPos * 12 + 10,
        cached = peg$resultsCache[key];

    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }

    s0 = peg$currPos;

    if (input.charCodeAt(peg$currPos) === 45) {
      s1 = peg$c19;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c20);
      }
    }

    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$c21();
    }

    s0 = s1;
    peg$resultsCache[key] = {
      nextPos: peg$currPos,
      result: s0
    };
    return s0;
  }

  function peg$parseinteger() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 12 + 11,
        cached = peg$resultsCache[key];

    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }

    s0 = peg$currPos;
    s1 = peg$currPos;
    s2 = [];

    if (peg$c22.test(input.charAt(peg$currPos))) {
      s3 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s3 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c23);
      }
    }

    if (s3 !== peg$FAILED) {
      while (s3 !== peg$FAILED) {
        s2.push(s3);

        if (peg$c22.test(input.charAt(peg$currPos))) {
          s3 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s3 = peg$FAILED;

          if (peg$silentFails === 0) {
            peg$fail(peg$c23);
          }
        }
      }
    } else {
      s2 = peg$FAILED;
    }

    if (s2 !== peg$FAILED) {
      s1 = input.substring(s1, peg$currPos);
    } else {
      s1 = s2;
    }

    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$c24(s1);
    }

    s0 = s1;
    peg$resultsCache[key] = {
      nextPos: peg$currPos,
      result: s0
    };
    return s0;
  }

  function getEmptyHand() {
    return {
      p: 0,
      l: 0,
      n: 0,
      s: 0,
      g: 0,
      b: 0,
      r: 0,
      k: 0,
      "+p": 0,
      "+l": 0,
      "+n": 0,
      "+s": 0,
      "+b": 0,
      "+r": 0
    };
  }

  peg$result = peg$startRuleFunction();

  if (peg$result !== peg$FAILED && peg$currPos === input.length) {
    return peg$result;
  } else {
    if (peg$result !== peg$FAILED && peg$currPos < input.length) {
      peg$fail(peg$endExpectation());
    }

    throw peg$buildStructuredError(peg$maxFailExpected, peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null, peg$maxFailPos < input.length ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1) : peg$computeLocation(peg$maxFailPos, peg$maxFailPos));
  }
}

module.exports = {
  SyntaxError: peg$SyntaxError,
  parse: peg$parse
};